import { FigureVarData, isFigureVarData } from "./FigureVarData";

export interface FigureGroupData extends Record<string, string | FigureVarData[]> {
  id: string;
  dataGroupName: string;
  dataGroupLabel: string;
  properties: FigureVarData[];
}

/**
 * Type guard to check if an object is a FigureGroupData
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureGroupData
 */
export const isFigureGroupData = (obj: unknown): obj is FigureGroupData => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureGroupData;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.dataGroupName !== "string") {
    return false;
  }
  if (typeof chkObj.dataGroupLabel !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((row) => !isFigureVarData(row))) {
    return false;
  }
  return true;
};
